import script from "./SettingsItemPoliticalAffiliation.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemPoliticalAffiliation.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemPoliticalAffiliation.vue?vue&type=style&index=0&id=04a9319a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a9319a"]])

export default __exports__